var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1918_171741",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1918_171741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6693 12.668H5.33594C4.96927 12.668 4.65538 12.5374 4.39427 12.2763C4.13316 12.0152 4.0026 11.7013 4.0026 11.3346V2.0013C4.0026 1.63464 4.13316 1.32075 4.39427 1.05964C4.65538 0.798524 4.96927 0.667969 5.33594 0.667969H10.0026L14.0026 4.66797V11.3346C14.0026 11.7013 13.872 12.0152 13.6109 12.2763C13.3498 12.5374 13.0359 12.668 12.6693 12.668ZM9.33594 5.33464V2.0013H5.33594V11.3346H12.6693V5.33464H9.33594ZM2.66927 15.3346C2.3026 15.3346 1.98872 15.2041 1.7276 14.943C1.46649 14.6819 1.33594 14.368 1.33594 14.0013V4.66797H2.66927V14.0013H10.0026V15.3346H2.66927Z",
    fill: "#362689"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file-copy.8894e9deba9c0cf43f2b60ef97a0bc9c.svg";
export { ForwardRef as ReactComponent };